<app-top-nav></app-top-nav>

<div class="container">
  <div class="main-content">
    <!-- Header -->
    <div class="header-section">
      <div class="breadcrumb">
        <span class="breadcrumb-item">Team</span>
        <span class="breadcrumb-separator">|</span>
        <span class="breadcrumb-item">P910584</span>
        <span class="breadcrumb-separator">|</span>
        <span class="breadcrumb-item">Performance review</span>
      </div>
      <h1>{{ employeeName }}</h1>
    </div>

    <!-- Review Form -->
    <form (ngSubmit)="onSubmit()" #reviewForm="ngForm" class="review-form">
      <!-- Performance Review -->
      <div class="form-section">
        <label for="performance-review" class="section-label"
          >Performance Review</label
        >
        <textarea
          id="performance-review"
          name="performanceReview"
          [(ngModel)]="formData.performanceReview"
          placeholder="Example"
          class="form-textarea"
          rows="4"
          required
        ></textarea>
      </div>

      <!-- Skill -->
      <div class="form-section">
        <label for="skill" class="section-label">Skill</label>
        <textarea
          id="skill"
          name="skill"
          [(ngModel)]="formData.skill"
          placeholder="Enter your answer"
          class="form-textarea small"
          rows="2"
          required
        ></textarea>
      </div>

      <!-- Skill Comments -->
      <div class="form-section">
        <label for="skill-comments" class="section-label">Skill comments</label>
        <textarea
          id="skill-comments"
          name="skillComments"
          [(ngModel)]="formData.skillComments"
          placeholder="Enter your answer"
          class="form-textarea small"
          rows="2"
          required
        ></textarea>
      </div>

      <!-- Development Actions -->
      <div class="form-section">
        <label for="development-actions" class="section-label"
          >Development Actions</label
        >
        <textarea
          id="development-actions"
          name="developmentActions"
          [(ngModel)]="formData.developmentActions"
          placeholder="Example"
          class="form-textarea"
          rows="4"
          required
        ></textarea>
      </div>

      <!-- Employee Aspirations -->
      <div class="form-section">
        <label for="employee-aspirations" class="section-label"
          >Employee Aspirations</label
        >
        <textarea
          id="employee-aspirations"
          name="employeeAspirations"
          [(ngModel)]="formData.employeeAspirations"
          placeholder="Example"
          class="form-textarea"
          rows="4"
          required
        ></textarea>
      </div>

      <!-- Employee Contribution -->
      <div class="form-section">
        <label for="employee-contribution" class="section-label"
          >Employee contribution</label
        >
        <textarea
          id="employee-contribution"
          name="employeeContribution"
          [(ngModel)]="formData.employeeContribution"
          placeholder="Example"
          class="form-textarea"
          rows="4"
          required
        ></textarea>
      </div>

      <!-- Talents -->
      <div class="form-section">
        <label for="talents" class="section-label">Talents</label>
        <textarea
          id="talents"
          name="talents"
          [(ngModel)]="formData.talents"
          placeholder="Example"
          class="form-textarea"
          rows="4"
          required
        ></textarea>
      </div>

      <!-- Retention Risk -->
      <div class="form-section">
        <label class="section-label">Retention Risk</label>
        <div class="radio-group">
          <div class="radio-option" *ngFor="let option of retentionRiskOptions">
            <input
              type="radio"
              [id]="'retention-' + option.value"
              name="retentionRisk"
              [value]="option.value"
              [(ngModel)]="formData.retentionRisk"
              class="radio-input"
            />
            <label [for]="'retention-' + option.value" class="radio-label">
              {{ option.label }}
            </label>
          </div>
        </div>
      </div>

      <!-- Form Actions -->
      <div class="form-actions">
        <button type="button" class="btn btn-cancel" (click)="onCancel()">
          Cancel
        </button>
        <button
          type="submit"
          class="btn btn-submit"
          [disabled]="!isFormValid()"
        >
          Submit
        </button>
      </div>
    </form>
  </div>
</div>
